import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import BodyClass from '@plone/volto/helpers/BodyClass/BodyClass';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import {
  toBackendLang,
  withServerErrorCode,
} from '@plone/volto/helpers/Utils/Utils';
import { getNavigation } from '@plone/volto/actions/navigation/navigation';
import config from '@plone/volto/registry';

import Pagina404 from '../../../../components/busca/Pagina404';
import { montarUrl, secoesDoMenu } from '../../../../components/busca/busca';

// 404 no DS. O menu vem do navegador: no servidor o App pede o menu do caminho
// que não existe e ele chega vazio (por isso o core também o pede aqui), então
// os atalhos das seções aparecem depois que a página carrega.
const NotFound = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const lang = useSelector((state) => state.intl.locale);
  const itens = useSelector((state) => state.navigation?.items || []);

  useEffect(() => {
    dispatch(
      getNavigation(
        config.settings.isMultilingual ? `/${toBackendLang(lang)}` : '/',
        config.settings.navDepth,
      ),
    );
  }, [dispatch, lang]);

  return (
    <>
      <BodyClass className="page-not-found" />
      <Helmet title="Página não encontrada" />
      <Pagina404
        secoes={secoesDoMenu(itens)}
        onBuscar={(termo) => history.push(montarUrl({ termo }))}
      />
    </>
  );
};

export default withServerErrorCode(404)(NotFound);
